import { RSAA } from 'redux-api-middleware';
import { RTC, RTCOutgoingCommand } from '../utils/commons';

export const FETCH_INBOX_REQUEST = '@@messenger/FETCH_INBOX_REQUEST';
export const FETCH_INBOX_SUCCESS = '@@messenger/FETCH_INBOX_SUCCESS';
export const FETCH_INBOX_FAILURE = '@@messenger/FETCH_INBOX_FAILURE';

export const fetchThreads = nextUrl => {
  const url = nextUrl || `/api/threads/user_inbox/`;
  return {
    [RSAA]: {
      endpoint: url,
      method: 'GET',
      types: [FETCH_INBOX_REQUEST, FETCH_INBOX_SUCCESS, FETCH_INBOX_FAILURE]
    }
  };
};

export const FETCH_THREAD_REQUEST = '@@messenger/FETCH_THREAD_REQUEST';
export const FETCH_THREAD_SUCCESS = '@@messenger/FETCH_THREAD_SUCCESS';
export const FETCH_THREAD_FAILURE = '@@messenger/FETCH_THREAD_FAILURE';

export const fetchThread = id => {
  const url = `/api/threads/${id}/`;
  return {
    [RSAA]: {
      endpoint: url,
      method: 'GET',
      types: [FETCH_THREAD_REQUEST, FETCH_THREAD_SUCCESS, FETCH_THREAD_FAILURE]
    }
  };
};

export const FETCH_THREAD_MESSAGES_REQUEST =
  '@@messenger/FETCH_THREAD_MESSAGES_REQUEST';
export const FETCH_THREAD_MESSAGES_SUCCESS =
  '@@messenger/FETCH_THREAD_MESSAGES_SUCCESS';
export const FETCH_THREAD_MESSAGES_FAILURE =
  '@@messenger/FETCH_THREAD_MESSAGES_FAILURE';

export const fetchThreadMessages = (threadId, nextUrl) => {
  const url = nextUrl || `/api/messages/?thread=${threadId}`;
  return {
    [RSAA]: {
      endpoint: url,
      method: 'GET',
      types: [
        FETCH_THREAD_MESSAGES_REQUEST,
        FETCH_THREAD_MESSAGES_SUCCESS,
        FETCH_THREAD_MESSAGES_FAILURE
      ]
    }
  };
};

export const MARK_AS_READ_REQUEST = '@@messenger/MARK_AS_READ_REQUEST';
export const MARK_AS_READ_SUCCESS = '@@messenger/MARK_AS_READ_SUCCESS';
export const MARK_AS_READ_FAILURE = '@@messenger/MARK_AS_READ_FAILURE';
export const markThreadAsRead = threadId => {
  return {
    [RSAA]: {
      endpoint: `/api/threads/${threadId}/mark_thread_as_read/`,
      method: 'POST',
      types: [MARK_AS_READ_REQUEST, MARK_AS_READ_SUCCESS, MARK_AS_READ_FAILURE]
    }
  };
};

export const THREAD_JOIN_REQUEST = '@@rtc_msg/THREAD_JOIN_REQUEST';
export const THREAD_JOIN_SUCCESS = '@@rtc_msg/THREAD_JOIN_SUCCESS';
export const joinThreadRoom = threadId => {
  return {
    [RTC]: {
      body: {
        command: RTCOutgoingCommand.THREAD_JOIN,
        thread_id: threadId
      },
      request: THREAD_JOIN_REQUEST
    }
  };
};

export const THREAD_LEAVE_REQUEST = '@@rtc_msg/THREAD_LEAVE_REQUEST';
export const THREAD_LEAVE_SUCCESS = '@@rtc_msg/THREAD_LEAVE_SUCCESS';
export const leaveThreadRoom = threadId => {
  return {
    [RTC]: {
      body: {
        command: RTCOutgoingCommand.THREAD_LEAVE,
        thread_id: threadId
      },
      request: THREAD_LEAVE_REQUEST
    }
  };
};

export const THREAD_MESSAGE_REQUEST = '@@rtc_msg/THREAD_MESSAGE_REQUEST';
export const THREAD_MESSAGE_SUCCESS = '@@rtc_msg/THREAD_MESSAGE_SUCCESS';
export const messageThreadRoom = (threadId, message) => {
  return {
    [RTC]: {
      body: {
        command: RTCOutgoingCommand.THREAD_MESSAGE,
        thread_id: threadId,
        message: message
      },
      request: THREAD_MESSAGE_REQUEST
    }
  };
};

export const THREAD_MESSAGE_RECEIVED = '@@rtc_msg/THREAD_MESSAGE_RECEIVED';
export const NEW_MSG_NOTIFICATION_RECEIVED =
  '@@rtc_msg/NEW_MSG_NOTIFICATION_RECEIVED';
